import { Component, AfterViewInit, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'user-help',
  standalone: false,
  templateUrl: './user-help.component.html',
  styleUrls: ['./user-help.component.css']
})
export class HelpUserComponent implements AfterViewInit, OnInit {
  @ViewChild('userHelpDialog', { static: true }) userHelpDialog: TemplateRef<any>;
  private dialogRef: MatDialogRef<any>;
  constructor(private _dialog: MatDialog){}
 
  ngOnInit(): void {
    
  }

  ngAfterViewInit() {
    
  }

  openHelpUserModal(): void {
    this.dialogRef = this._dialog.open(this.userHelpDialog, {
      disableClose: false,
      width: '751px',
      height: '611px',
      maxWidth: '80vw',
      maxHeight: '85vh',
      position: { top: '90px' },
      panelClass: 'user-help-dialog-panel'
    });
  }


  closeHelp(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}